import { render, staticRenderFns } from "./Optimizer.vue?vue&type=template&id=2051b6cc&scoped=true"
import script from "./Optimizer.vue?vue&type=script&lang=js"
export * from "./Optimizer.vue?vue&type=script&lang=js"
import style0 from "./Optimizer.vue?vue&type=style&index=0&id=2051b6cc&prod&lang=less"
import style1 from "./Optimizer.vue?vue&type=style&index=1&id=2051b6cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2051b6cc",
  null
  
)

export default component.exports